import { Plural, Trans } from '@lingui/react'
import { observer } from 'mobx-react-lite'
import React from 'react'

import { useRoot } from '../../app/useRoot'
import { AlertModal } from '../../common/AlertModal'
import { PrimaryButton } from '../../common/Buttons'
import { FCompanyBranchStatusFragment } from '../../graph/generated'
import { useDelayedOrder } from '../../hooks/useDelayedOrder'
import { useShopStatus } from '../../hooks/useShopStatus'
import { i18n } from '../../i18n'

interface IProps {
  status: FCompanyBranchStatusFragment
}

export const ShopClosingTimeModal = observer<IProps>(({ status }) => {
  const { user, order } = useRoot()
  const { decision, openingIn, closedNote } = useShopStatus({
    status,
    // Do not want update here as it would be showing modal every time :)
    updateInterval: 0,
  })

  const { canBeDelayed, isEnabled } = useDelayedOrder()

  if (order.isDelayed) {
    // don't show modal if user has previous chosen time of delivery
    return null
  }

  const userCanPreOrder = canBeDelayed() && isEnabled

  return (
    <AlertModal
      isOpen={
        (decision === 'Closed' || decision === 'OpeningSoon') &&
        !user.closingTimeAlertHidden
      }
      onClose={user.hideClosingTime}
      headerText={
        userCanPreOrder
          ? i18n.t`Pre-orders only`
          : i18n.t`We are closed right now`
      }
    >
      <p>
        {closedNote ||
          i18n.t`We're sorry, but we do not accept new orders at this time.`}
      </p>
      {decision === 'OpeningSoon' && (
        <p>
          <Trans>
            You can prepare your order because we are{' '}
            <Plural
              value={openingIn}
              one="opening in 1 minute"
              other="opening in # minutes"
            />
            !
          </Trans>
        </p>
      )}
      {userCanPreOrder && (
        <PrimaryButton
          onClick={() => {
            user.hideClosingTime()
            order.openTimePicker()
          }}
        >
          <Trans>Select preorder time</Trans>
        </PrimaryButton>
      )}
    </AlertModal>
  )
})
